import { css } from '@emotion/react'
import { Tooltip, colors, font } from 'plume-ui'
import { IcomoonIcon } from '../../../../atoms/IcomoonIcon'
import { VerticalDivider } from '../../../../atoms/VerticalDivider'

type Props = {
  companyName: string
  closePanel: () => void
}

export const StatusPanelHeader: React.FC<Props> = ({
  companyName,
  closePanel,
}) => {
  return (
    <div
      css={css`
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 24px;
        border-bottom: 1px solid ${colors.border};
      `}
    >
      <div
        css={css`
          font-weight: ${font.weight.bold};
          font-size: 16px;
          line-height: 150%;
        `}
        className="company-name"
      >
        {companyName}
      </div>
      <div
        css={css`
          height: 100%;
          display: flex;
          align-items: center;
        `}
      >
        <VerticalDivider height="80%" />
        <Tooltip
          className="close-icon-tooltip"
          label="ステータスパネルを閉じる"
          place="bottom"
        >
          <div
            className="close"
            css={css`
              padding: 14px;
              cursor: pointer;
            `}
            onClick={closePanel}
          >
            <IcomoonIcon
              name="close-panel"
              css={css`
                font-size: 20px;
                color: ${colors.text};
              `}
            />
          </div>
        </Tooltip>
      </div>
    </div>
  )
}
